import { useMutation, useQueryClient } from "@tanstack/react-query";
import { BasicInfoValues } from "../schema/basic-info.schema";
import { Member } from "src/redux/types/_customer.type";
import { AxiosError } from "axios";
import { memberKeys } from "./useFetchMembers";
import { toast } from "react-toastify";
import { addBasicInfo } from "src/redux/api/_customer.api";

interface AddBasicInfoVariables {
  memberId: number;
  values: BasicInfoValues;
  subscriptionId: number;
}

export const useBasicInfoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<Member, AxiosError, AddBasicInfoVariables>({
    mutationFn: ({ memberId, values }) => addBasicInfo(memberId, values),
    onSuccess: (_, { subscriptionId }) => {
      queryClient.invalidateQueries({
        queryKey: memberKeys.list(subscriptionId),
      });
      toast.success("Member updated successfully");
    },
    onError: (error) => {
      toast.error("Failed to update member");
      console.error(error);
    },
  });
};
